const o = {
  id: "NewYorkPick10",
  logo: !0,
  name: "Pick 10",
  style: {
    colorPrimary: "#ffd200"
  }
};
export {
  o as default
};
